<input #fileInput (change)="onChangeLoad($event)" type="file" id="fileinput" />
@if (!textControl.isLoading) {
  <mat-icon
    class="fullscreen-icon"
    matTooltip="{{ 'fullscreen' | translate }}"
    matTooltipPosition="above"
    (click)="enterFullscreen()"
  >
    fullscreen
  </mat-icon>
}
<div class="text-control-container" #container [class.loading]="textControl.isLoading">
  @if (!textControl.isLoading && textControl.isFullscreen) {
    <mat-icon
      class="exit-fullscreen-icon"
      attr.title="{{ 'exitFullscreen' | translate }}"
      matTooltipPosition="above"
      (click)="exitFullscreen()"
    >
      fullscreen_exit
    </mat-icon>
  }
</div>
@if (textControl.isLoading) {
  <div class="loader" *appLoader="true"></div>
}
<app-editor-autosave-indicator
  [isSaving]="isSaving"
  [isSaved]="isSaved"
  [isSaveFailed]="isSaveFailed"
></app-editor-autosave-indicator>
